import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

const GiveFeedback = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      maxWidth="max-content"
      sx={{ backgroundColor: "#146ED2", padding: "10px", borderRadius: "4px" }}
    >
      <PriorityHighIcon fontSize="large" sx={{ color: "white" }} />
      <Typography color="white" fontWeight={800}>
        This form is waiting for you to give feedback
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "white",
          color: "#146ED2",
          height: "35px",
          fontWeight: 800,
          borderRadius: "2px",
          ml: 2,
          "&:hover": { backgroundColor: "white" },
        }}
      >
        Give Feedback
      </Button>
    </Box>
  );
};

export default GiveFeedback;
